module.exports = function (settingsService) {
    return {
        restrict: 'A',
        link(scope, element, attrs) {
            settingsService.getSettingValue(attrs.settingGroup, attrs.settingName).then((value) => {
                element.html(value);
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/settings/settings-html.directive.js